import { NetworkStatus, useSuspenseQuery } from '@apollo/client';

import { useParams } from '@xing-com/crate-core-router';
import { GetInstantApplyJobDataDocument } from '@xing-com/crate-jobs-graphql';
import type { GetInstantApplyJobDataQuery } from '@xing-com/crate-jobs-graphql';
import { useVisibleJobTypePolicies } from '@xing-com/crate-jobs-hooks';

type UseInstantApplyJobDataReturnValue = {
  isJobDataError: boolean;
  isLoading: boolean;
  job: GetInstantApplyJobDataQuery['job'];
  refetch: () => void;
};

export const useInstantApplyJobData = (): UseInstantApplyJobDataReturnValue => {
  const { slug } = useParams<{ slug: string }>();
  useVisibleJobTypePolicies();
  const { data, error, refetch, networkStatus } = useSuspenseQuery(
    GetInstantApplyJobDataDocument,
    {
      variables: { slug },
      notifyOnNetworkStatusChange: true,
    }
  );

  const job = data?.job;

  return {
    isJobDataError:
      !!error ||
      !job ||
      job.__typename !== 'VisibleJob' ||
      job.application?.__typename !== 'JobXingApplication',
    isLoading: networkStatus === NetworkStatus.refetch,
    job,
    refetch,
  };
};
